export default __webpack_public_path__ + "static/media/Tijofi_Ts_10.884a86ed.jpg";